import React from 'react'
import { StandardColumn } from '../../../../components/StandardPage'
import { OverflowCell } from '../../../../components/OverflowCell'

export const compositionScreenKey = 'composition_product'

export interface ProductListItem {
  id: number
  code: string
  name: string
  collection: string
  episode: string
  family: string
  grades: string
  groups: string
  colors: string
  coverImageUrl: string | null
  coverImageScale: number | null
  coverImagePosX: number | null
  coverImagePosY: number | null
}

const getFirstWithEllipsis = (content: string): string => {
  if (!content) return '-'
  const parts = content.split(',').map((s) => s.trim()).filter(Boolean)
  if (parts.length === 0) return '-'
  if (parts.length === 1) return parts[0]
  return `${parts[0]}...`
}

const buildTooltipText = (content: string): string => {
  if (!content) return ''
  const items = content.split(',').map((s) => s.trim()).filter(Boolean)
  return items.length > 1 ? items.join('\n') : content
}

const summarizedCell = (value: string) => (
  <OverflowCell text={buildTooltipText(value)} forceTooltip={value?.includes(',')}>
    {getFirstWithEllipsis(value)}
  </OverflowCell>
)

export const buildCompositionColumns = (): StandardColumn<ProductListItem>[] => [
  { id: 'code', label: 'Código' },
  { id: 'name', label: 'Produto' },
  { id: 'collection', label: 'Coleção', defaultHidden: true, cell: (product) => summarizedCell(product.collection) },
  { id: 'episode', label: 'Episódio', defaultHidden: true, cell: (product) => summarizedCell(product.episode) },
  { id: 'family', label: 'Família', cell: (product) => summarizedCell(product.family) },
  { id: 'grades', label: 'Grades', cell: (product) => summarizedCell(product.grades) },
  { id: 'groups', label: 'Grupos', cell: (product) => summarizedCell(product.groups) },
  { id: 'colors', label: 'Cores', cell: (product) => summarizedCell(product.colors) },
]
